import { FC } from 'react'
import RemoveImageSvg from 'icons/circle_x.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import styles from 'components/features/pfm/RemoveMediaButton/RemoveMediaButton.styl'


export const RemoveMediaButton: FC = () => {
  return (
    <div className={ styles.removeButton }>
      <div className={ styles.removeIcon }>
        <SvgIcon src={ RemoveImageSvg } />
      </div>
    </div>
  )
}
